// extracted by mini-css-extract-plugin
export default {"section_item":"addYearlyRecap_section_item__5Ihrl","handleDelete":"addYearlyRecap_handleDelete__fLgMy","no_spinner":"addYearlyRecap_no_spinner__nfL5f"};